/* istanbul ignore file */

import React from "react";
import { ToolTips } from "@px/px_design_system";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

import ToolTipMessages from "../../../Utilities/ToolTip/TooltipMessages";
import ToastMsg from "../../../Utilities/ToastMsg";
import ArchiveIcon from "../../../../svgs/ArchiveIcon";
import { PlatformFlatfile } from "../../../Utilities/FlatFileComponent/Platform/index";
import { archived__deals__sheet } from "./blueprint";
import { listenerArchiveDeals } from "./listener";

const ArchiveDeals = ({ isImportEnabled, orgData, registerDeals }) => {
  const abortController = new AbortController();
  const flatfileClose = (errorJson = []) => {
    abortController.abort();
    if (errorJson.length) {
      const props = {
        icon: ["fas", "exclamation-triangle"],
        toastTitle: `Please find the failed deals by clicking the 'Download CSV' button`,
        toastSubTitle: `You can use the downloaded csv to re-upload the failed deals`,
        isDownloadable: true,
        csvProps: {
          json: errorJson,
          moveToFirstPosition: ["name", "error_message"],
          removeColumns: ["asset.aspect_ratio"],
          renameHeaders: { name: "deal_name" },
          filename: "Failed_Archiving_Deals",
        },
      };
      toast.error(<ToastMsg {...props} />, {
        toastId: "failed-archive_deals",
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
      });
    }
    registerDeals();
  };

  const postProcessFields = [{ key: "archived", process: (value) => value }];

  return (
    <div className="archive__button">
      <ToolTips
        disabled={!isImportEnabled}
        text={
          !isImportEnabled
            ? ToolTipMessages.ARCHIVE_DEAL.noPermission
            : ToolTipMessages.ARCHIVE_DEAL.title
        }
      >
        <div id="flatfile--deals__archive">
          {isImportEnabled ? (
            <PlatformFlatfile
              name="archive__deals"
              fields={archived__deals__sheet}
              listener={listenerArchiveDeals(
                orgData,
                flatfileClose,
                abortController,
                postProcessFields
              )}
              submitActionName="submitActionArchiveDeals"
              renderButton={ArchiveIcon}
            />
          ) : (
            ArchiveIcon
          )}
        </div>
      </ToolTips>
    </div>
  );
};

ArchiveDeals.propTypes = {
  isImportEnabled: PropTypes.bool,
  orgData: PropTypes.shape(),
  registerDeals: PropTypes.func,
};

export default ArchiveDeals;
